import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

function PerformanceMapList({  location, setLocation, fullWidth, callback }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');

  return <Autocomplete
    value={location}
    options={options}
    //loading={isLoading}
    onChange={(event, newValue) => {
      setLocation(newValue)
      if (callback) callback();
    }}
    inputValue={inputValue}
    onInputChange={(event, newInputValue) => {
      setInputValue(newInputValue);
    }}
    style={{
      width: fullWidth ? '100%' : 300,
      marginRight: 10
    }}
    autoHighlight
    getOptionLabel={(option) => option.place_name}
    renderOption={(option) => {
      return (
        <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }}>
          {option.place_name}
        </Box>
      );
    }}
    renderInput={(params) => (
      <TextField {...params} placeholder={t("choose-performance-map-or-add-new-one")} margin="normal" />
    )}
  />
 
}

export default withWidth()(PerformanceMapList);
